// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import AccessModeController from "./access_mode_controller"
application.register("access-mode", AccessModeController)

import ApplicationQuestionFormController from "./application_question_form_controller"
application.register("application-question-form", ApplicationQuestionFormController)

import ApplicationQuestionSortController from "./application_question_sort_controller"
application.register("application-question-sort", ApplicationQuestionSortController)

import CheckboxselectController from "./checkboxselect_controller"
application.register("checkboxselect", CheckboxselectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommentsCounterController from "./comments_counter_controller"
application.register("comments-counter", CommentsCounterController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContestActivationController from "./contest_activation_controller"
application.register("contest-activation", ContestActivationController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EntryDragController from "./entry_drag_controller"
application.register("entry-drag", EntryDragController)

import FadeOutController from "./fade_out_controller"
application.register("fade-out", FadeOutController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FinalizeRankingsController from "./finalize_rankings_controller"
application.register("finalize-rankings", FinalizeRankingsController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormSubmissionController from "./form_submission_controller"
application.register("form-submission", FormSubmissionController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import InteractionController from "./interaction_controller"
application.register("interaction", InteractionController)

import JudgingRoundFormController from "./judging_round_form_controller"
application.register("judging-round-form", JudgingRoundFormController)

import JudgingRoundShowController from "./judging_round_show_controller"
application.register("judging-round-show", JudgingRoundShowController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import TooltipEmailDisplayController from "./tooltip_email_display_controller"
application.register("tooltip-email-display", TooltipEmailDisplayController)

import UidLookupController from "./uid_lookup_controller"
application.register("uid-lookup", UidLookupController)

import WordCounterController from "./word_counter_controller"
application.register("word-counter", WordCounterController)
